import { MachineSpecificationOfflineService } from '~/sqlite/services/machineSpecification';

export class SpecificationLocalDataSource extends MachineSpecificationOfflineService {}

export const specificationLocal = new SpecificationLocalDataSource();
